(function () {
    'use strict';

    angular
        .module('app')
        .controller('GamesController', GamesController);

    GamesController.$inject = ['$state',];

    function GamesController($state) {
        // var vm = this;


        activate();

        function activate() {
            // Run on load
            if ($state && $state.current && $state.current.name === 'games') {
                $state.go('games.list');
            }
        }
    }
})();